import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Sober DS (v2) — Checkbox. Radix root + indicator, sober-* tokens only.
 * 16px square, outline border at rest, primary fill when checked (no colored
 * border accent — emphasis comes from the primary fill + focus ring).
 */
export type CheckboxProps = React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>;

export const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-so-sm border border-sober-border bg-sober-surface',
      'transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sober-primary-fg',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'data-[state=checked]:bg-sober-primary-fg data-[state=checked]:border-sober-primary-fg data-[state=checked]:text-white',
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      <Check className="size-3.5" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = 'Checkbox';
